import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Row, Col } from "antd";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import TimeInput from "../TimeInput";
import DateInput from "../DateInput";
import NumberInput from "../NumberInput";

const { Option } = Select;

const NotifyTypeInput = (props: any) => {
  const { value, placeholder, onChange } = props;
  const [options, setOptions] = useState([
    { id: "email", name: "Email" },
    { id: "sms", name: "SMS" },
  ]);
  const [timeOptions, setTimeOptions] = useState([
    { id: "5", name: "5 min" },
    { id: "10", name: "10 min" },
    { id: "15", name: "15 min" },
    { id: "30", name: "30 min" },
    { id: "45", name: "45 min" },
    { id: "60", name: "60 min" },
    { id: "custom", name: "Custom" },
  ]);

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col span={12} className="pr-2">
          <Select
            showSearch
            value={value?.notifyVia}
            className="w-full"
            placeholder="Notify via"
            allowClear
            onChange={(val) => {
              if(val === undefined && value?.notifyTime === undefined){
                onChange(undefined);
              }
              else{
                onChange({
                  notifyVia: val,
                  notifyTime: value?.notifyTime,
                  customTime: value?.customTime,
                  type: "notifyType",
                });
              }
            }}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {options?.map((option, index) => (
              <Option key={index} value={option.id}>
                {option.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={12}>
          <Select
            showSearch
            allowClear
            value={value?.notifyTime}
            className="w-full"
            placeholder="Notify time"
            onChange={(val) => {
              if(val === undefined && value?.notifyVia === undefined){
                onChange(undefined);
              }
              else{
                onChange({
                  notifyVia: value?.notifyVia,
                  notifyTime: val,
                  customTime: val === 'custom'? 0: undefined,
                  type: "notifyType",
                });
              }
            }}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {timeOptions?.map((option, index) => (
              <Option key={index} value={option.id}>
                {option.name}
              </Option>
            ))}
          </Select>
        </Col>

        {value?.notifyTime === "custom" && (
          <Col span={24} className="mt-3">
            <NumberInput
              placeholder={"Enter notify time"}
              value={value?.customTime}
              onChange={(val) => {
                onChange({
                  notifyVia: value?.notifyVia,
                  notifyTime: "custom",
                  customTime: val,
                  type: "notifyType",
                });
              }}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default NotifyTypeInput;
